import { createContext, useContext, useEffect, useState } from "react";
import { Branding } from "../types";
import appApi from "../api/app/appApi";

interface AppContextType {
    branding?: Branding;
    baseQuoterPath?: string;
    contentPath?: string;
    gtmContainerId?: string;
    deploymentMode?: string;
    initialParams: URLSearchParams;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [context, setContext] = useState<AppContextType>({
        initialParams: new URLSearchParams(window.location.search),
    });

    useEffect(() => {
        const init = async () => {
            // fetch context.
            const appCtx = await appApi.getAppContext();
            setContext((prev) => ({ ...prev, ...appCtx }));
        };
        init();
    }, []);

    return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};

export function useAppContext(): AppContextType {
    const ctx = useContext(AppContext);
    if (!ctx) {
        throw new Error("useAppContext must be used inside an AppContextProvider");
    }
    return ctx;
}
